import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MenteeGroupData } from '../../providers/mentee-group-data'
import { UserData } from '../../providers/user-data'
import { GlobalVariable } from '../../global'
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { ToastController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the MentorToMenteeGroupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-mentor-to-mentee-group',
  templateUrl: 'assign-mentor-to-mentee-group.html',
})
export class AssignMentorToMenteeGroupPage {
  menteegroups: any
  mentors: any
  addusertogroupForm: FormGroup
  duplicateErrorArray: any
  usertype: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private menteeGroupData: MenteeGroupData, private userData: UserData,
    private formBuilder: FormBuilder, private toastCtrl: ToastController, private alertCtrl: AlertController, private storage: Storage) {
    this.storage.get('usertype').then((value) => {
      this.usertype = value;
      if (this.usertype != GlobalVariable.Admin) {
        this.navCtrl.setRoot(HomePage);
      }
    });
    this.addusertogroupForm = this.formBuilder.group({
      groupid: ['', Validators.required],
      users: ['', Validators.required]
    });
  }


  ionViewDidLoad() {
    this.getMenteeGroup()
    this.getUserList()
  }


  getMenteeGroup() {
    this.menteeGroupData.getMenteeGroup().subscribe(
      res => {
        this.menteegroups = res['data']
      },
      err => {
        this.presentAlert('Error', 'Something went wrong, try again')
      }
    )
  }

  getUserList() {
    this.menteeGroupData.getMentorByAdmin().subscribe(
      res => {
        this.mentors = res['data']
        this.mentors.map(item => {
          item.usertype = GlobalVariable.Mentor
        })
      },
      err => {
        this.presentAlert('Error', 'Something went wrong, try again')
      }
    )
  }

  onSubmit(value) {
    this.duplicateErrorArray = []
    this.menteeGroupData.addMentorToMenteeGroup(value).subscribe(
      res => {
        if (res['success']) {
          this.presentToast(res['message'])
          this.addusertogroupForm.reset()
        }
      },
      err => {
        console.log(err)
        if (err.error.data.length > 0) {
          this.duplicateErrorArray = err.error.data
        }
      }
    )
  }

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top',
      showCloseButton: true
    });
    toast.present();
  }

  presentAlert(title, msg) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: ['Dismiss']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/assign-mentor-to-mentee-group/assign-mentor-to-mentee-group.ts